<template>
  <v-container>
    <v-main>
      <!--<SignIn/>-->
      -put a password up 
      -better design. fuck hello kitty
      -why doesnt the api.itsasmileairport.com/api/users reveal anything? Because CORS in the route file? Should test..
      -make sure https is renewing with certbot. and not just 2 months cert or whatever
      <br >
      Notes:<br>
      -name, now boarding, gate 1,2,3,4

DONE?:
-get rid of the time column
-recenter the logo
-recenter the logo
-Date instead of Day
-change the colors
-add an airlines column
-add a flight number
-Status instead of schedule
-get rid of patients
-color of columsn dark and light blue
-Hide the Date? Depends

-password protect the site
-Add a flashy notification
make homepage / router go to table
https://codepen.io/jjperezaguinaga/pen/yuBdq
https://cssdeck.com/labs/pure-css3-plane-animation-demo
https://scontent-lga3-1.xx.fbcdn.net/v/t1.0-9/11225183_1601605923422241_5793931017614933905_n.jpg?_nc_cat=102&_nc_sid=ba80b0&_nc_ohc=NjrjesEEp5IAX_2sqGw&_nc_ht=scontent-lga3-1.xx&oh=3eddbcd936ff60725166dbe947aa0b14&oe=5F7BC79F

Instructions: 
-make sure you save the excel file as text cells and note Date cells
-understand that the excel file only shows the current day (today's date) that matches the next_regular_appointment column
    </v-main>
  </v-container>
</template>

<script>
  /*import SignIn from '../components/SignIn.vue';*/
  /*import HelloWorld from '@/components/HelloWorld.vue'*/

  export default {
    name: 'SignInScreen',

    components: {
      /*SignIn*/
    },
  }
</script>
